<div class="row">
  <div class=" col-sm-0 col-lg-2"></div>
  <div class=" col-sm-12 col-lg-8" id="announcements">
    <span *ngFor="let a of messages">
      <p-panel [toggleable]="true" header="{{a.title}}" [collapsed]="false" class="m-2" expandIcon="pi pi-chevron-up"
      collapseIcon="pi pi-chevron-down">
      <p class="m-3">
        <span [innerHtml]="a.msg | safeHtml"></span>
      </p>
    </p-panel>
    </span>
  </div>
  <div class=" col-sm-0 col-lg-2"></div>
</div>